import i18n from 'i18n';
import userStateValueFormatter from 'utils/valueFormatters/userStateValueFormatter';
import { dateFilterParams } from '../../shared/constants/index';
import { COMMON_GRID_COLUMN_FIELD_NAMES } from '../../shared/commonGrid/grid-enums';
import { stringArrayComparator } from '../../shared/commonGrid/grid-util';

export default [
  {
    headerName: '',
    field: COMMON_GRID_COLUMN_FIELD_NAMES.Action,
    cellRenderer: 'actionMenuCellRenderer',
  },
  {
    headerName: i18n.t('user.grid.userId'),
    field: 'userID',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'userID',
  },
  {
    headerName: i18n.t('user.grid.email'),
    field: 'email',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'email',
  },
  {
    headerName: i18n.t('user.grid.first'),
    field: 'firstName',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'firstName',
  },
  {
    headerName: i18n.t('user.grid.last'),
    field: 'lastName',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'lastName',
  },
  {
    headerName: i18n.t('user.grid.roles'),
    field: 'assignedRoles',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    filterParams: { textCustomComparator: stringArrayComparator },
    tooltipField: 'assignedRoles',
  },
  {
    headerName: i18n.t('user.grid.state'),
    field: 'state',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    valueFormatter: userStateValueFormatter,
    tooltipValueGetter: userStateValueFormatter,
  },
  {
    headerName: i18n.t('user.grid.lastLogin'),
    field: 'lastlogin',
    sortable: true,
    filter: 'agDateColumnFilter',
    floatingFilter: true,
    resizable: true,
    filterParams: dateFilterParams,
    cellRenderer: 'datetimeCellRenderer',
    tooltipField: 'lastlogin',
  },
  {
    headerName: i18n.t('user.grid.lastLoginIp'),
    field: 'lastLoginAddress',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'lastLoginAddress',
  },
];
